const messages = {
  'menu.print': '打印',
  'menu.freight': '货运',
  'menu.jdfreightbill': '京东货运单管理',
  'menu.sffreightbill': '顺丰货运单管理',
  'menu.dhlfreightbill': 'DHL货运单管理',
  'menu.fedexfreightbill': 'FedEx货运单管理',
  'menu.emsfreightbill': 'EMS货运单管理',
  'menu.jdfreightbillreport': '京东货运单报告',
  'menu.sffreightbillreport': '顺丰货运单报告',
  'menu.dhlfreightbillreport': 'DHL货运单报告',
  'menu.fedexfreightbillreport': 'FedEx货运单报告',
  'menu.emsfreightbillreport': 'EMS货运单报告',
  'menu.report': '报告',
  'menu.settings':'设置',
  'menu.systemmanagement': '系统管理',
  'menu.masterdata': '主数据管理',
  'menu.emailtemplate': '邮件模板管理',
  'menu.carriers': '承运商管理',
  'menu.paymentaccount': '承运商支付账户管理',
  'menu.carrieraccount':'承运商账户管理',
  'menu.freightbillaccount':'货运单账户管理',
  'menu.porequest':'PO请求',
  'menu.shipments':'货物',
  'menu.details':'详情',
  'menu.dninformation':'DN信息',
  'menu.exportdeclarationinformation':'出口报关信息',
  'menu.shipmentinformation':'货物追踪信息',
  'menu.freightinformation':'货运信息',
  'menu.company': '公司管理',
  'menu.department': '部门管理',
  'menu.country': '国家/地区管理',
  'menu.state': '州/省管理',
  'menu.hscode': 'HS编码管理',
  'menu.legalunit': '法定单位管理',
  'menu.sparrowtemplate': 'Sparrow模板管理',
  'menu.addressbook': '地址簿管理',
  'menu.expressservice': '创建货件',
  'menu.createdomesticexpressorder': '国内快递',
  'menu.updatedomesticexpressorder': '更新国内快递',
  'menu.createinternationalexpressorder': "国际快递",
  'menu.updateinternationalexpressorder': "更新国际快递",
  'menu.expressorderdetail': '货件详情',
  'menu.expressorderprocess': '处理货件',
  'menu.expressorderreport': '货件报告',
  'menu.expressordertodolist': '待审批',
  'menu.dashboard': '仪表盘',
  'menu.shipmentsreport': '货物报告',
  'menu.purchaserequest': '采购请求',
  'menu.purchaserequesttodo': '采购请求待办事项',
  'menu.purchaserequestreport': '采购请求报告',
  'menu.purchaserequestdetail': '采购请求详情',
  'menu.updatepurchaserequest': '更新采购请求',
  'menu.copypurchaserequest': '复制采购请求',
  'menu.changepurchaserequest': '变更采购请求',
  'menu.delegation': '委托管理'
};
export default messages;
